import { api } from "./configs/axiosConfigs"

export const PermissionAPI = {
    get: async (data?:any) => {
        const response = await api.get(
            '/permissions', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getByUserType: async (data:any) => {
        const response = await api.get(
            '/companyDefaultPermissions', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    updateByUserType: async (id:number, data: any) => {
        const response = await api.patch(
            `/companyDefaultPermissions/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getUser: async (data?:any) => {
        const response = await api.get(
            '/permissionsUser', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createUser: async (data: any) => {
        const response = await api.post(
            '/permissionsUser/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    updateUser: async (id:number, data: any) => {
        const response = await api.patch(
            `/permissionsUser/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}